import { NgModule, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TestRegistryService } from '../../services/test-registry.service';
import { createAPITestDefinitions } from './api-test-definitions';
import { AuthService } from '../../../services/auth/auth.service';
import { CompletionProvidersApiService } from '../../../services/api/completion-providers-api-service';
import { SupabaseClientService } from '../../../services/client/supabase-client.service';
import { InstructionsApiService } from '../../../services/api/instructions-api.service';
import { Subject } from 'rxjs';

/**
 * Module for API and HTTP-related tests
 */
@NgModule({})
export class APITestsModule implements OnDestroy {
  private destroy$ = new Subject<void>();
  
  constructor(
    private testRegistry: TestRegistryService,
    private http: HttpClient,
    private auth: AuthService,
    private providersService: CompletionProvidersApiService,
    private supabase: SupabaseClientService,
    private instructionService: InstructionsApiService
  ) {
    this.registerCategory();
    this.registerTests();
  }

  /**
   * Register the API tests category
   */
  private registerCategory(): void {
    this.testRegistry.registerCategory({
      id: 'api-tests',
      title: 'API & HTTP Tests',
      description: 'Test HTTP requests, authentication, and API endpoints',
      icon: 'api',
      color: 'accent',
      order: 2
    });
  }

  /**
   * Register all API test definitions
   */
  private registerTests(): void {
    const testDefinitions = createAPITestDefinitions(
      this.http,
      this.auth,
      this.providersService,
      this.supabase,
      this.instructionService,
      this.destroy$
    );
    
    testDefinitions.forEach(test => {
      this.testRegistry.registerTest(test);
    });
    
    console.log(`Registered ${testDefinitions.length} API tests`);
  }

  /**
   * Cleanup when module is destroyed
   */
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}